import { message } from "antd";
import CopyToClipboard from "react-copy-to-clipboard";
import { getEnv } from "@/libs/cfg";

const getEmbeddingCode = (donationPagePath: string) => {
  const donationPageLink = `${getEnv("WEB_HOST")}${donationPagePath}`;
  return `<iframe src="${donationPageLink}" width="500" height="600" frameborder="0"></iframe>`;
}

export default function DonationEmbedding({ donationPagePath }: { donationPagePath: string }) {
  return (
    <div className="share" style={{ width: '500px' }}>
      <p style={{ fontSize: '14px', color: '#a0a0a0', marginBottom: '16px', fontWeight: 'bold' }}>Copy the following code to embed your donation checkout page within your website, and make it easier for your visitors to donate! This feature is compatible with WordPress and other site builders utilizing iFrame.</p>
      <p>
        <CopyToClipboard
          text={getEmbeddingCode(donationPagePath)}
          onCopy={() => message.success("Code copied")}
        >
          <p className="flex">
            <i className="embedding-code !text-wrap !break-all">{getEmbeddingCode(donationPagePath)}</i>
            <i className="cursor-pointer">Copy</i>
          </p>
        </CopyToClipboard>
      </p>
    </div>
  );
}